import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { TenantsService } from 'src/app/Data/Services/tenants.service';

@Component({
  selector: 'docrelay-settings',
  standalone: true,
  imports: [
      CommonModule,
      MatExpansionModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      TranslateModule,
      MatCheckboxModule,
      MatButtonModule,
      FormsModule,
      ReactiveFormsModule,],
  templateUrl: './docrelay-settings.component.html',
  styleUrls: ['./docrelay-settings.component.scss']
})
export class DocrelaySettingsComponent implements OnInit{
  public docrelaySettingsFG: FormGroup = new FormGroup({
    docrelayCompany: new FormControl(''),
    docrelayUserName: new FormControl(''),
    docrelayPassword: new FormControl(''),
    docrelayTarget: new FormControl(''),
    });
    constructor(
      protected sanitizer: DomSanitizer,
      private tenantsService: TenantsService,
    ) {}
    ngOnInit(): void {
      this.tenantsService.currentTenantSettings.subscribe((res) => {
        if (res) {
          console.log('received from server:', res);
          this.docrelaySettingsFG.patchValue({
           
              docrelayCompany: res.docrelayCompany ?? '',
              docrelayUserName: res.docrelayUserName ?? '',
              docrelayPassword: res.docrelayPassword ?? '',
              docrelayTarget: res.docrelayTarget ?? '',
            
          });
        }
      });
    }
  
    public getFormData(): any {
      return this.docrelaySettingsFG.value;
    }
  
  
    onClear() {
      
        this.docrelaySettingsFG.reset();
      
      
    }
}
